
const isUnavailable = (scheduleRun) => {

   // Previously had some logic about not allowing GLI sales within 12 hours.
   // That is no longer needed, but I'll keep this function around in case we need it later.
    return false;
}

module.exports = class TDSScheduleReducer {

    static reduce = (data) => {
        if (data && data.scheduleProducts) {
            data.scheduleProducts.forEach((scheduleProduct) => {
                if (scheduleProduct.segments) {
                    const filteredSegments = [];
                    for (let i = 0; i < scheduleProduct.segments.length; i++) {
                        const segment = scheduleProduct.segments[i];
                        if (
                            i == 0 ||  // always include the first segment
                            i == scheduleProduct.segments.length - 1 || // always include the last segment
                            segment.transfer || // always include a transfer segment
                            (
                                i < scheduleProduct.segments.length - 1 &&
                                scheduleProduct.segments[i + 1].transfer  // also include the segment before a transfer
                            )
                        ) {
                            filteredSegments.push({
                                schedule: {
                                    carrier: {
                                        carrierId: segment.schedule.carrier.carrierId,
                                        code: segment.schedule.carrier.code,
                                        name: segment.schedule.carrier.name,
                                    },
                                    scheduleNumber: segment.schedule.scheduleNumber,
                                    scheduleUuid: segment.schedule.scheduleUuid,
                                    trueNumber: segment.schedule.trueNumber
                                },
                                departStop: {
                                    stopUuid: segment.departStop.stopUuid,
                                    stationName: segment.departStop.stationName,
                                    address: segment.departStop.address,
                                    city: segment.departStop.city,
                                    state: segment.departStop.state,
                                    timeZone: segment.departStop.timeZone,
                                },
                                arriveStop: {
                                    stopUuid: segment.arriveStop.stopUuid,
                                    stationName: segment.arriveStop.stationName,
                                    address: segment.arriveStop.address,
                                    city: segment.arriveStop.city,
                                    state: segment.arriveStop.state,
                                    timeZone: segment.arriveStop.timeZone,
                                },
                                departTime: segment.departTime,
                                arriveTime: segment.arriveTime,
                                layoverDuration: segment.layoverDuration,
                                transfer: segment.transfer,
                                travelDuration: segment.travelDuration,
                            });
                        }
                    }
                    scheduleProduct.segments = filteredSegments;
                }
                if (scheduleProduct.scheduleRun) {
                    if (scheduleProduct.scheduleRun.carrier) {
                        scheduleProduct.scheduleRun.carrier = {
                            carrierId: scheduleProduct.scheduleRun.carrier.carrierId,
                            code: scheduleProduct.scheduleRun.carrier.code,
                        };
                    }
                    /*
                    if (scheduleProduct.scheduleRun.origin) {
                        scheduleProduct.scheduleRun.origin = {
                            stopUuid: scheduleProduct.scheduleRun.origin.stopUuid,
                            stationName: scheduleProduct.scheduleRun.origin.stationName,
                            city: scheduleProduct.scheduleRun.origin.city,
                            state: scheduleProduct.scheduleRun.origin.state,
                            timeZone: scheduleProduct.scheduleRun.origin.timeZone,
                            zip: scheduleProduct.scheduleRun.origin.zip.trim(),
                        };
                    }
                    if (scheduleProduct.scheduleRun.destination) {
                        scheduleProduct.scheduleRun.destination = {
                            stopUuid: scheduleProduct.scheduleRun.destination.stopUuid,
                            stationName: scheduleProduct.scheduleRun.destination.stationName,
                            city: scheduleProduct.scheduleRun.destination.city,
                            state: scheduleProduct.scheduleRun.destination.state,
                            timeZone: scheduleProduct.scheduleRun.destination.timeZone,
                            zip: scheduleProduct.scheduleRun.destination.zip.trim(),
                        };
                    }
                    */
                    scheduleProduct.scheduleRun = {
                        carrier: scheduleProduct.scheduleRun.carrier,
                        destination: scheduleProduct.scheduleRun.destination,
                        origin: scheduleProduct.scheduleRun.origin,
                        alreadyDeparted: scheduleProduct.scheduleRun.alreadyDeparted,
                        isUnavailable: isUnavailable(scheduleProduct.scheduleRun),
                        arriveTime: scheduleProduct.scheduleRun.arriveTime,
                        departTime: scheduleProduct.scheduleRun.departTime,
                        expired: scheduleProduct.scheduleRun.expired,
                        mileage: scheduleProduct.scheduleRun.mileage,
                        pastSalesCutoffTime: scheduleProduct.scheduleRun.pastSalesCutoffTime,
                        remainingCapacity: scheduleProduct.scheduleRun.remainingCapacity,
                        scheduleNumber: scheduleProduct.scheduleRun.scheduleNumber,
                        scheduleUuid: scheduleProduct.scheduleRun.scheduleUuid,
                        soldOut: scheduleProduct.scheduleRun.soldOut,
                        travelDate: scheduleProduct.scheduleRun.travelDate,
                        travelDuration: scheduleProduct.scheduleRun.travelDuration,
                        trueNumber: scheduleProduct.scheduleRun.trueNumber,
                    };
                }
                delete scheduleProduct.fares;
                /*
                 * The following are needed in book call, so don't delete them
                 *
                delete scheduleProduct.scheduleRun.origin.displayBusinessName;
                delete scheduleProduct.scheduleRun.origin.latitude;
                delete scheduleProduct.scheduleRun.origin.longitude;
                delete scheduleProduct.scheduleRun.origin.extraInfoRequired;
                delete scheduleProduct.scheduleRun.origin.doorToDoor;
                delete scheduleProduct.scheduleRun.destination.displayBusinessName;
                delete scheduleProduct.scheduleRun.destination.latitude;
                delete scheduleProduct.scheduleRun.destination.longitude;
                delete scheduleProduct.scheduleRun.destination.extraInfoRequired;
                delete scheduleProduct.scheduleRun.destination.doorToDoor;
                */
                delete scheduleProduct.amenities;
                if (scheduleProduct.railgunFares) {
                    if (scheduleProduct.railgunFares.Adult?.length) {
                        scheduleProduct.railgunFares.Adult.forEach((adult) => {
                            adult.fares = adult.fares.map((fare) => {
                                return {
                                    amount: fare.amount,
                                    type: fare.type === 'ADVANCED_FARE' ? 'Advanced Fare' : fare.type === 'MILEAGE' ? 'Mileage' : fare.type,
                                    markup: fare.markup,
                                    mileageFareId: fare.mileageFareDetails?.fareId,
                                    specialFareId: fare.specialFareDetails?.fareId
                                };
                            });
                        })
                    }
                    if (scheduleProduct.railgunFares.Senior?.length) {
                        scheduleProduct.railgunFares.Senior.forEach((senior) => {
                            senior.fares = senior.fares.map((fare) => {
                                return {
                                    amount: fare.amount,
                                    type: fare.type === 'ADVANCED_FARE' ? 'Advanced Fare' : fare.type === 'MILEAGE' ? 'Mileage' : fare.type,
                                    markup: fare.markup,
                                    mileageFareId: fare.mileageFareDetails?.fareId,
                                    specialFareId: fare.specialFareDetails?.fareId
                                };
                            });
                        })
                    }
                    if (scheduleProduct.railgunFares.Child?.length) {
                        scheduleProduct.railgunFares.Child.forEach((child) => {
                            child.fares = child.fares.map((fare) => {
                                return {
                                    amount: fare.amount,
                                    type: fare.type === 'ADVANCED_FARE' ? 'Advanced Fare' : fare.type === 'MILEAGE' ? 'Mileage' : fare.type,
                                    markup: fare.markup,
                                    mileageFareId: fare.mileageFareDetails?.fareId,
                                    specialFareId: fare.specialFareDetails?.fareId
                                };
                            });
                        })
                    }
                    scheduleProduct.railgunFares = {
                        Adult: scheduleProduct.railgunFares.Adult,
                        Senior: scheduleProduct.railgunFares.Senior,
                        Child: scheduleProduct.railgunFares.Child,
                    };
                }
            })
        }
        return data;
    }
}